import { http } from "./api-config";
import store from "../store";

const apiClient = http(process.env.VUE_APP_CONFIG_SERVICE);
export default {
  async getWidgetList() {
    let headers = {};
    if (store.state.variables.cashWidgetList) {
      headers = { "isSilentAPI": true };
    }
    store.commit('variables/setCashWidgetList', true)
    const res = await apiClient.get("widgets", { headers });
    return res.data;
    // try {
    //     const res = await apiClient.get('widgets')
    //     return {status: true, data: res.data}
    // } catch (err) {
    //     return {status: false, data: null, message: err.message}
    // }
  },
  async getWidgetById(id) {
    const res = await apiClient.get(`widgets/${id}`);
    return res.data;
  },
  async createWidget(data) {
    const res = await apiClient.post("widgets", data);
    return res.data;
  },
  async updateWidget(data) {
    const res = await apiClient.put("widgets", data);
    return res.data;
  },
  async deleteWidget(id) {
    const res = await apiClient.delete(`widgets/${id}`);
    return res.data;
  },
  async getWidgetFile(widgetId, fileId, tenantId) {
    const res = await apiClient.get(
      `widgets/${widgetId}&${fileId}?tenant=${tenantId}`, {
      responseType: "blob",
    }
    );
    return res.data;
  },
};
